import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Form } from 'antd';
import BaseComponent from 'components/BaseComponent';
import styledComp, { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import CustomButton from 'components/CustomButton';
import FormInput from 'components-desktop/FormInput';
import Panel from 'components-desktop/Panel';
import helpers from 'misc/helpers';
import FormApplyPayment from './FormApplyPayment';

const propTypes = {
  payment: PropTypes.object.isRequired,
  onInvoicePaymentApply: PropTypes.func.isRequired,

  form: PropTypes.object.isRequired,
};

@autobind
class FormSearchApplyInvoice extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      invoice: null,
      isSearchButtonEnable: true,
    };
  }

  async searchInvoice(values) {
    try {
      this.setState({
        isSearchButtonEnable: false,
      });

      // Get invoice.
      const params = { invoiceNumber: helpers.extraFormInputValue(values, 'invoiceNumber') };
      const invoice = await this.callServiceForRemoteObject('/invoice/get_list', params);

      this.setState({
        invoice,
      });
    } finally {
      this.setState({
        isSearchButtonEnable: true,
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.searchInvoice(values);
      }
    });
  }

  clearInvoice() {
    this.setState({
      invoice: null,
    });
    this.props.form.setFieldsValue({
      invoiceNumber: '',
    });
  }

  onInvoicePaymentApply() {
    this.props.onInvoicePaymentApply();
  }

  renderContent() {
    const { payment, form } = this.props;
    const { invoice, isSearchButtonEnable } = this.state;

    return (
      <FlexColContainer
        width="match_parent"
        height="wrap_content"
        alignItems="center"
      >
        <Panel
          width="match_parent"
          height="wrap_content"
          margin="0 0 24px 0"
          color="yellow_gold"
          title="Search an Invoice to Apply Payment"
          icon="money-collect"
        >
          <styledComp.AntdForm
            width="match_parent"
            height="wrap_content"
            onSubmit={this.handleSubmit}
          >
            {/* Content */}
            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              padding="20px 20px"
            >
              <FlexRowContainer
                width="wrap_content"
                height="wrap_content"
                alignItems="flex-end"
              >
                <FormInput
                  width="200px"
                  height="wrap_content"
                  margin="0 16px 0 0"
                  form={form}
                  name="invoiceNumber"
                  label="Invoice Number"
                  max={120}
                  isRequired
                />

                <CustomButton
                  width="wrap_content"
                  height="32px"
                  margin="0 0 6px 0"
                  backgroundColor="yellow_gold"
                  fontSize="14px"
                  type="primary"
                  loading={!isSearchButtonEnable}
                  htmlType="submit"
                >
                  SEARCH
                </CustomButton>
              </FlexRowContainer>
            </FlexColContainer>
          </styledComp.AntdForm>

          {invoice &&
            <FormApplyPayment
              width="match_parent"
              height="wrap_content"
              payment={payment}
              invoice={invoice}
              clearInvoice={this.clearInvoice}
              onInvoicePaymentApply={this.onInvoicePaymentApply}
            />
          }
        </Panel>
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
FormSearchApplyInvoice.propTypes = propTypes;

export default Form.create()(FormSearchApplyInvoice);
